














































import { Player } from "@gaia-project/engine";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ButtonData, WarningsPreference } from "../data";
import { enabledButtonWarnings } from "../data/warnings";
import { CommandController, MoveButtonController } from "../logic/buttons/types";
import { buttonRichTextLabel, callOnShow } from "../logic/buttons/utils";
import BoardAction from "./BoardAction.vue";
import Booster from "./Booster.vue";
import RichTextView from "./Resources/RichTextView.vue";
import SpecialAction from "./SpecialAction.vue";
import TechTile from "./TechTile.vue";

@Component({
  components: {
    RichTextView,
    Booster,
    TechTile,
    BoardAction,
    SpecialAction,
  },
})
export default class MoveButton extends Vue implements MoveButtonController {
  @Prop()
  public button!: ButtonData;

  @Prop()
  public controller: CommandController;

  private modalShow = false;

  public key = "key"; //only to force re-render

  private rangePreselect: number = null;

  mounted() {
    const keyListener = (e) => {
      const b = this.button;
      if (b.hide) {
        return;
      }

      if (this.modalShow) {
        if (!b.modal.canActivate()) {
          return false;
        }
        if (e.key == "Enter") {
          this.handleOK();
          return false;
        }
      }

      const primary = document.getElementsByClassName("btn btn-primary");
      if (e.key == "Enter") {
        if (primary.length > 0) {
          (primary[0] as HTMLElement).click();
          return;
        }
      }
      if (primary.length > 0) {
        // we're showing a modal dialog
        return false;
      }

      if (b.shortcuts?.includes(e.key)) {
        if (this.rangePreselect) {
          this.handleRangeClick(this.rangePreselect ?? b.times[0]);
        } else {
          this.controller.handleButtonClick(b);
        }
      } else if (b.times && isFinite(Number(e.key))) {
        this.rangePreselect = Number(e.key);
      }
    };
    window.addEventListener("keydown", keyListener);
    this.$on("hook:beforeDestroy", () => window.removeEventListener("keydown", keyListener));
  }

  updated() {
    this.button.buttonController = this;

    if (!this.button.hide) {
      callOnShow(this.button);
    }
  }
  modalCancel(arg: string) {
    this.button.modal.show(false);
    this.$emit("cancel");
  }

  setButton(b: ButtonData, key: string) {
    this.button = b;
    this.key = key; //forces re-render
  }

  setModalShow(value: boolean) {
    this.modalShow = value;
  }

  handleOK() {
    const b = this.button;
    b.modal.show(false);
    this.controller.emitButtonCommand(b);
  }

  handleRangeClick(times: number) {
    this.controller.emitButtonCommand(this.button, null, { times });
  }

  get player(): Player {
    const engine = this.$store.state.data;
    return engine.player(engine.currentPlayer);
  }

  get active() {
    return this.controller.isActiveButton(this.button);
  }

  get label() {
    return buttonRichTextLabel(this.button);
  }

  hover() {
    this.button.hover?.enter(this.button);
  }

  leave() {
    this.button.hover?.leave(this.button);
  }

  get warningPreference(): WarningsPreference {
    return this.$store.state.preferences.warnings;
  }

  get variant(): string {
    return enabledButtonWarnings(this.button, this.$store.state.preferences).length > 0 &&
      this.warningPreference !== WarningsPreference.Tooltip
      ? "warning"
      : "secondary";
  }
}
